// extracted by mini-css-extract-plugin
module.exports = {"videoEmbed":"VideoEmbed_videoEmbed__DdpE5","wrapper":"VideoEmbed_wrapper__Ba15J","caption":"VideoEmbed_caption__0ePZF"};